import { render, staticRenderFns } from "./OrderComponent.vue?vue&type=template&id=5850acbc&scoped=true&"
import script from "./OrderComponent.vue?vue&type=script&lang=js&"
export * from "./OrderComponent.vue?vue&type=script&lang=js&"
import style0 from "./OrderComponent.vue?vue&type=style&index=0&id=5850acbc&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5850acbc",
  null
  
)

export default component.exports